//对象拷贝
export default (obj = {}) => {
    let newObj = {};
    Object.keys(obj).forEach(key => {
        newObj[key] = obj[key];
    });
    return newObj;
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/copyObject.js